import { useState } from "react";

import {
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import { DossierPriority } from "types/DossierPriority";
import { formatEnumValueWithSpaces } from "utils/formatEnumValueWithSpaces";

export interface DossierPrioritySelectorProps {
    defaultValue: DossierPriority;
    onChange: (newValue: DossierPriority) => void;
}

export function DossierPrioritySelector(props: DossierPrioritySelectorProps) {
    const [selectedDossierPriority, setSelectedDossierPriority] =
        useState<DossierPriority>(props.defaultValue);

    const handleChange = (event: SelectChangeEvent<DossierPriority>) => {
        setSelectedDossierPriority(event.target.value);

        props.onChange(event.target.value);
    };

    return (
        <>
            <FormControl
                margin="dense"
                fullWidth
            >
                <InputLabel>Priority</InputLabel>
                <Select
                    fullWidth
                    margin="dense"
                    value={selectedDossierPriority}
                    onChange={handleChange}
                    input={<OutlinedInput label="Priority" />}
                >
                    {Object.values(DossierPriority).map((value) => (
                        <MenuItem
                            key={value}
                            value={value}
                        >
                            <ListItemText
                                primary={formatEnumValueWithSpaces<DossierPriority>(
                                    value,
                                )}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
}
